import AdUnit from "./AdUnit";
import { ADSENSE_IN_ARTICLE_SLOT } from "../../config/adsense.js";

export default function InArticleAd() {
  return (
    <AdUnit
      slot={ADSENSE_IN_ARTICLE_SLOT}
      className="ad-slot--inarticle"
      format="fluid"
      layout="in-article"
      style={{ display: "block", textAlign: "center" }}
      fullWidthResponsive="true"
    />
  );
}
